import cn from "classnames"

import { Flex, Spin } from "@/atoms"
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined
} from "@/icons"

import styles from "./StatusKai.module.scss"

import type { StatusKaiProps } from "."

const ICONS_STATUS_KAI = {
  confirmed: ExclamationCircleOutlined,
  falsePositive: CheckCircleOutlined,
  undetermined: ClockCircleOutlined
}
export const getStatus = (isFalsePositive?: boolean | null | undefined) => {
  if (isFalsePositive) return "falsePositive"

  return isFalsePositive === false ? "confirmed" : "undetermined"
}

export const StatusKai = (props: StatusKaiProps) => {
  const {
    t,
    children,
    inProgress,
    isFalsePositive,
    status = getStatus(isFalsePositive)
  } = props
  const Icon = ICONS_STATUS_KAI[status]
  const colorCN = cn({
    [styles.confirmed]: status === "confirmed" && !inProgress,
    [styles.falsePositive]: status === "falsePositive" && !inProgress,
    [styles.undetermined]: status === "undetermined" || inProgress
  })

  return (
    <Flex gap={inProgress ? 8 : 4} align="center" className={colorCN}>
      {inProgress && (
        <>
          <Spin
            size="small"
            indicator={<LoadingOutlined spin className={colorCN} />}
          />
          <span className={styles.text}>
            {t(
              "card.analyzingDataFlow",
              t("triage.drawer.kai.sast.card.analyzingDataFlow")
            )}
          </span>
        </>
      )}
      {!inProgress && (
        <>
          {Icon && <Icon className={styles.icon} />}
          <span className={styles.text}>
            {children ||
              t(`card.${status}`, t(`triage.drawer.kai.sast.card.${status}`))}
          </span>
        </>
      )}
    </Flex>
  )
}
